(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/components/draw-card-panel.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/components/draw-card-panel.js');
"use strict";


const clx = svs.components.lbUtils.clx;
const DrawCardPanel = _ref => {
  let children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    title = _ref.title,
    ariaLabel = _ref.ariaLabel,
    hasHiddenAria = _ref.hasHiddenAria;
  const blockName = 'pg_draw_card__panel';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--untitled")]: !title
  }, className);
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    "aria-label": ariaLabel,
    className: classNames,
    onClick: onClick
  }, title && React.createElement("div", {
    "aria-hidden": Boolean(ariaLabel),
    className: "pg_draw_card__panel__title"
  }, title), React.createElement("div", {
    "aria-hidden": Boolean(ariaLabel),
    className: "pg_draw_card__panel__content"
  }, children));
};
setGlobal('svs.components.tipsen.drawCard.components.DrawCardPanel', DrawCardPanel);

 })(window);